export const REQUEST_VIEWPROJECTSUPERADMINDASHBOARD_DATA = 'REQUEST_VIEWPROJECTSUPERADMINDASHBOARD_DATA';
export const VIEWPROJECTSUPERADMINDASHBOARD_DATA_RECEIVED = 'VIEWPROJECTSUPERADMINDASHBOARD_DATA_RECIEVED';